import { combineReducers } from 'redux'
import createSubscriptionPaymentReducer, {
    createSubscriptionPaymentActions
} from '@app-store/slices/subscriptionPayment/create'
import onePaymentReducer, { onePaymentActions } from '@app-store/slices/subscriptionPayment/one'
export const subscriptionPaymentReducers = combineReducers({
    create: createSubscriptionPaymentReducer,
    one: onePaymentReducer
})

export const subscriptionPaymentActions = {
    create: createSubscriptionPaymentActions,
    one: onePaymentActions
}
